// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PublicSchemaTypes from '../../../graphql/public/PublicSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type OrganisationJustIdQueryVariables = PublicSchemaTypes.Exact<{ [key: string]: never; }>;


export type OrganisationJustIdQuery = (
  { __typename?: 'Query' }
  & { organisation?: PublicSchemaTypes.Maybe<(
    { __typename?: 'OrganisationModelGQLBase' }
    & Pick<PublicSchemaTypes.OrganisationModelGqlBase, 'id'>
  )> }
);

export type HowUserCanResetPasswordQueryVariables = PublicSchemaTypes.Exact<{
  accountNameOrEmail: PublicSchemaTypes.Scalars['NonEmptyString'];
}>;


export type HowUserCanResetPasswordQuery = (
  { __typename?: 'Query' }
  & { howUserCanResetPassword?: PublicSchemaTypes.Maybe<(
    { __typename?: 'PasswordResetStrategy' }
    & Pick<PublicSchemaTypes.PasswordResetStrategy, 'strategy'>
  )> }
);

export type GetUserSecurityQuestionsQueryVariables = PublicSchemaTypes.Exact<{
  accountName: PublicSchemaTypes.Scalars['NonEmptyString'];
}>;


export type GetUserSecurityQuestionsQuery = (
  { __typename?: 'Query' }
  & Pick<PublicSchemaTypes.Query, 'getUserSecurityQuestions'>
);

export type GenerateUserResetPasswordLinkUsingSecurityQuestionsMutationVariables = PublicSchemaTypes.Exact<{
  accountName: PublicSchemaTypes.Scalars['NonEmptyString'];
  questionAnswers: Array<PublicSchemaTypes.SecurityQuestionsDataInput> | PublicSchemaTypes.SecurityQuestionsDataInput;
}>;


export type GenerateUserResetPasswordLinkUsingSecurityQuestionsMutation = (
  { __typename?: 'Mutation' }
  & Pick<PublicSchemaTypes.Mutation, 'generateUserResetPasswordLinkUsingSecurityQuestions'>
);

export type GenerateResetPasswordLinkMutationVariables = PublicSchemaTypes.Exact<{
  email: PublicSchemaTypes.Scalars['EmailAddressWithTLD'];
  organisationId: PublicSchemaTypes.Scalars['PositiveInt'];
}>;


export type GenerateResetPasswordLinkMutation = (
  { __typename?: 'Mutation' }
  & Pick<PublicSchemaTypes.Mutation, 'generateResetPasswordLink'>
);

export type SetNewPasswordMutationVariables = PublicSchemaTypes.Exact<{
  userId: PublicSchemaTypes.Scalars['PositiveInt'];
  password: PublicSchemaTypes.Scalars['String'];
  token: PublicSchemaTypes.Scalars['String'];
}>;


export type SetNewPasswordMutation = (
  { __typename?: 'Mutation' }
  & { resetPassword?: PublicSchemaTypes.Maybe<(
    { __typename?: 'UserModelBase' }
    & Pick<PublicSchemaTypes.UserModelBase, 'userIdentity'>
  )> }
);


export const OrganisationJustIdDocument = gql`
    query organisationJustId {
  organisation {
    id
  }
}
    `;

/**
 * __useOrganisationJustIdQuery__
 *
 * To run a query within a React component, call `useOrganisationJustIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationJustIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationJustIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationJustIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganisationJustIdQuery, OrganisationJustIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganisationJustIdQuery, OrganisationJustIdQueryVariables>(OrganisationJustIdDocument, options);
      }
export function useOrganisationJustIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganisationJustIdQuery, OrganisationJustIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganisationJustIdQuery, OrganisationJustIdQueryVariables>(OrganisationJustIdDocument, options);
        }
export type OrganisationJustIdQueryHookResult = ReturnType<typeof useOrganisationJustIdQuery>;
export type OrganisationJustIdLazyQueryHookResult = ReturnType<typeof useOrganisationJustIdLazyQuery>;
export type OrganisationJustIdQueryResult = Apollo.QueryResult<OrganisationJustIdQuery, OrganisationJustIdQueryVariables>;
export const HowUserCanResetPasswordDocument = gql`
    query howUserCanResetPassword($accountNameOrEmail: NonEmptyString!) {
  howUserCanResetPassword(accountNameOrEmail: $accountNameOrEmail) {
    strategy
  }
}
    `;

/**
 * __useHowUserCanResetPasswordQuery__
 *
 * To run a query within a React component, call `useHowUserCanResetPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useHowUserCanResetPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHowUserCanResetPasswordQuery({
 *   variables: {
 *      accountNameOrEmail: // value for 'accountNameOrEmail'
 *   },
 * });
 */
export function useHowUserCanResetPasswordQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HowUserCanResetPasswordQuery, HowUserCanResetPasswordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HowUserCanResetPasswordQuery, HowUserCanResetPasswordQueryVariables>(HowUserCanResetPasswordDocument, options);
      }
export function useHowUserCanResetPasswordLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HowUserCanResetPasswordQuery, HowUserCanResetPasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HowUserCanResetPasswordQuery, HowUserCanResetPasswordQueryVariables>(HowUserCanResetPasswordDocument, options);
        }
export type HowUserCanResetPasswordQueryHookResult = ReturnType<typeof useHowUserCanResetPasswordQuery>;
export type HowUserCanResetPasswordLazyQueryHookResult = ReturnType<typeof useHowUserCanResetPasswordLazyQuery>;
export type HowUserCanResetPasswordQueryResult = Apollo.QueryResult<HowUserCanResetPasswordQuery, HowUserCanResetPasswordQueryVariables>;
export const GetUserSecurityQuestionsDocument = gql`
    query getUserSecurityQuestions($accountName: NonEmptyString!) {
  getUserSecurityQuestions(accountName: $accountName)
}
    `;

/**
 * __useGetUserSecurityQuestionsQuery__
 *
 * To run a query within a React component, call `useGetUserSecurityQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSecurityQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSecurityQuestionsQuery({
 *   variables: {
 *      accountName: // value for 'accountName'
 *   },
 * });
 */
export function useGetUserSecurityQuestionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserSecurityQuestionsQuery, GetUserSecurityQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserSecurityQuestionsQuery, GetUserSecurityQuestionsQueryVariables>(GetUserSecurityQuestionsDocument, options);
      }
export function useGetUserSecurityQuestionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserSecurityQuestionsQuery, GetUserSecurityQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserSecurityQuestionsQuery, GetUserSecurityQuestionsQueryVariables>(GetUserSecurityQuestionsDocument, options);
        }
export type GetUserSecurityQuestionsQueryHookResult = ReturnType<typeof useGetUserSecurityQuestionsQuery>;
export type GetUserSecurityQuestionsLazyQueryHookResult = ReturnType<typeof useGetUserSecurityQuestionsLazyQuery>;
export type GetUserSecurityQuestionsQueryResult = Apollo.QueryResult<GetUserSecurityQuestionsQuery, GetUserSecurityQuestionsQueryVariables>;
export const GenerateUserResetPasswordLinkUsingSecurityQuestionsDocument = gql`
    mutation generateUserResetPasswordLinkUsingSecurityQuestions($accountName: NonEmptyString!, $questionAnswers: [SecurityQuestionsDataInput!]!) {
  generateUserResetPasswordLinkUsingSecurityQuestions(
    accountName: $accountName
    questionAnswers: $questionAnswers
  )
}
    `;
export type GenerateUserResetPasswordLinkUsingSecurityQuestionsMutationFn = Apollo.MutationFunction<GenerateUserResetPasswordLinkUsingSecurityQuestionsMutation, GenerateUserResetPasswordLinkUsingSecurityQuestionsMutationVariables>;

/**
 * __useGenerateUserResetPasswordLinkUsingSecurityQuestionsMutation__
 *
 * To run a mutation, you first call `useGenerateUserResetPasswordLinkUsingSecurityQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUserResetPasswordLinkUsingSecurityQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUserResetPasswordLinkUsingSecurityQuestionsMutation, { data, loading, error }] = useGenerateUserResetPasswordLinkUsingSecurityQuestionsMutation({
 *   variables: {
 *      accountName: // value for 'accountName'
 *      questionAnswers: // value for 'questionAnswers'
 *   },
 * });
 */
export function useGenerateUserResetPasswordLinkUsingSecurityQuestionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateUserResetPasswordLinkUsingSecurityQuestionsMutation, GenerateUserResetPasswordLinkUsingSecurityQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateUserResetPasswordLinkUsingSecurityQuestionsMutation, GenerateUserResetPasswordLinkUsingSecurityQuestionsMutationVariables>(GenerateUserResetPasswordLinkUsingSecurityQuestionsDocument, options);
      }
export type GenerateUserResetPasswordLinkUsingSecurityQuestionsMutationHookResult = ReturnType<typeof useGenerateUserResetPasswordLinkUsingSecurityQuestionsMutation>;
export type GenerateUserResetPasswordLinkUsingSecurityQuestionsMutationResult = Apollo.MutationResult<GenerateUserResetPasswordLinkUsingSecurityQuestionsMutation>;
export type GenerateUserResetPasswordLinkUsingSecurityQuestionsMutationOptions = Apollo.BaseMutationOptions<GenerateUserResetPasswordLinkUsingSecurityQuestionsMutation, GenerateUserResetPasswordLinkUsingSecurityQuestionsMutationVariables>;
export const GenerateResetPasswordLinkDocument = gql`
    mutation generateResetPasswordLink($email: EmailAddressWithTLD!, $organisationId: PositiveInt!) {
  generateResetPasswordLink(email: $email, organisationId: $organisationId)
}
    `;
export type GenerateResetPasswordLinkMutationFn = Apollo.MutationFunction<GenerateResetPasswordLinkMutation, GenerateResetPasswordLinkMutationVariables>;

/**
 * __useGenerateResetPasswordLinkMutation__
 *
 * To run a mutation, you first call `useGenerateResetPasswordLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateResetPasswordLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateResetPasswordLinkMutation, { data, loading, error }] = useGenerateResetPasswordLinkMutation({
 *   variables: {
 *      email: // value for 'email'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useGenerateResetPasswordLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateResetPasswordLinkMutation, GenerateResetPasswordLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateResetPasswordLinkMutation, GenerateResetPasswordLinkMutationVariables>(GenerateResetPasswordLinkDocument, options);
      }
export type GenerateResetPasswordLinkMutationHookResult = ReturnType<typeof useGenerateResetPasswordLinkMutation>;
export type GenerateResetPasswordLinkMutationResult = Apollo.MutationResult<GenerateResetPasswordLinkMutation>;
export type GenerateResetPasswordLinkMutationOptions = Apollo.BaseMutationOptions<GenerateResetPasswordLinkMutation, GenerateResetPasswordLinkMutationVariables>;
export const SetNewPasswordDocument = gql`
    mutation setNewPassword($userId: PositiveInt!, $password: String!, $token: String!) {
  resetPassword(userId: $userId, password: $password, token: $token) {
    userIdentity
  }
}
    `;
export type SetNewPasswordMutationFn = Apollo.MutationFunction<SetNewPasswordMutation, SetNewPasswordMutationVariables>;

/**
 * __useSetNewPasswordMutation__
 *
 * To run a mutation, you first call `useSetNewPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetNewPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setNewPasswordMutation, { data, loading, error }] = useSetNewPasswordMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      password: // value for 'password'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useSetNewPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetNewPasswordMutation, SetNewPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetNewPasswordMutation, SetNewPasswordMutationVariables>(SetNewPasswordDocument, options);
      }
export type SetNewPasswordMutationHookResult = ReturnType<typeof useSetNewPasswordMutation>;
export type SetNewPasswordMutationResult = Apollo.MutationResult<SetNewPasswordMutation>;
export type SetNewPasswordMutationOptions = Apollo.BaseMutationOptions<SetNewPasswordMutation, SetNewPasswordMutationVariables>;